<template>
	<div class="one-slot-offer-detail template-layout">
		<OfferHeaderBlock
			:contentData="contentData"
			@closePopup="$emit('closePopup', $event)"
		/>
		<OfferRibbonBlock :contentData="contentData" />
		<OfferContentBlock
			:skin="contentData.attributes?.skin"
			:subtype="contentData.attributes?.subtype"
		>
			<template #content>
				<ResourceOrUtilityRewardsGrid
					:items="slotItems"
					:context="RewardsGridContext.POPUP"
				/>
			</template>
		</OfferContentBlock>
	</div>
</template>

<script lang="ts" setup>
import OfferContentBlock from "@/components/shop/blocks/OfferContentBlock.vue";
import OfferHeaderBlock from "@/components/shop/blocks/OfferHeaderBlock.vue";
import OfferRibbonBlock from "@/components/shop/blocks/OfferRibbonBlock.vue";
import ResourceOrUtilityRewardsGrid from "@/components/shop/blocks/parts/ResourceOrUtilityRewardsGrid.vue";
import type { ResourceOrUtilitySlotItem } from "@/types/shop";
import { type ShopItem } from "@/types/shop";
import { RewardsGridContext } from "@/types/ui";
import { computed } from "vue";

interface Props {
	contentData: ShopItem;
}

const { contentData } = defineProps<Props>();

const slotItems = computed(
	(): ResourceOrUtilitySlotItem[] | null =>
		(contentData.attributes?.slots?.[0]
			?.items as ResourceOrUtilitySlotItem[]) ?? null,
);
</script>

<style lang="scss" scoped></style>
